import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TemplateRenderer  {
    _originalTypeClassName = "zPMO.BO.TemplateRenderer";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TemplateRenderer.translate = translateService;
}
this.TemplateRendererKey = null;
this._key = this.TemplateRendererKey = 0; 
}

static translate: TranslateService;
_key: any;
private _TemplateRendererKey:any;
get TemplateRendererKey(): any {
    return this._TemplateRendererKey;
  }
set TemplateRendererKey(value: any) {
    this._TemplateRendererKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TemplateRendererKey == null || $this.TemplateRendererKey == 0;
            }


}